import { createAction, props } from '@ngrx/store';
import { SimplePagesContainer, SimplePage } from '../domain/simple-page';
import { PageType } from '../page-edit-screen/page-type';
import { ContentPageDetailDialogDataViewModel } from '../shared/components/content-page-detail-dialog/content-page-detail-dialog-data-view.model';
import { RedeemPageDetailDialogDataViewModel } from '../shared/components/redeem-page-detail-dialog/redeem-page-detail-dialog-data.view-model';

const feature = '[CXB Page Screen]';

export const loadCxbPageScreen = createAction(`${feature} Load page screen`);
export const loadCxbPageScreenSuccess = createAction(`${feature} Load page screen success`, props<{ pages: SimplePagesContainer }>());
export const loadCxbPageScreenFail = createAction(`${feature} Load page screen fail`, props<{ errorMessage: string }>());

export const createCxbContentPage = createAction(
  `${feature} Create content page`,
  props<{
    data: ContentPageDetailDialogDataViewModel;
  }>()
);

export const createCxbGenrePage = createAction(
  `${feature} Create genre page`,
  props<{
    data: ContentPageDetailDialogDataViewModel;
  }>()
);
export const createCxbRedeemPage = createAction(`${feature} Create redeem page`, props<{ data: RedeemPageDetailDialogDataViewModel }>());
export const createCxbPageSuccess = createAction(`${feature} Create page success`, props<{ pageType: PageType; page: SimplePage }>());
export const createCxbPageFail = createAction(`${feature} Create page fail`, props<{ errorMessage: string }>());
